import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * 「历史包裹追踪」深链（分批次-尾程：线路页 DSP 强提示、批次推送页横幅共用）。
 */

/** 「到达HUB时间」视图：历史包裹追踪 arrivalPointType 固定传 1 */
const ARRIVAL_POINT_TYPE_HUB = '1';

/**
 * 仓库当地当天日期（YYYY-MM-DD），只按仓库 timezoneLocation（IANA）计算，自带夏令时规则。
 * 不用固定偏移 timezone、浏览器时间兜底，避免夏令时切换或跨时区时日期错位。
 *
 * @return 当地日期；timezoneLocation 为空或非法时返回 null（调用方不渲染跳转）
 */
export const warehouseLocalDate = (timezoneLocation: string | null | undefined, now: dayjs.Dayjs = dayjs()): string | null => {
    if (!timezoneLocation) return null;
    try {
        const local = now.tz(timezoneLocation);
        return local.isValid() ? local.format('YYYY-MM-DD') : null;
    } catch {
        // 非法 IANA 名称时 dayjs.tz 抛 RangeError
        return null;
    }
};

/**
 * 历史包裹追踪深链（站内相对路径，stag / 线上自动对应各自域名）：到达日期起止均为仓库当地当天、仓库为当前 WHS、
 * 视图为「到达HUB时间」（arrivalPointType=1）；仓管跳 `/wms/delivery/parcel-sla-monitoring`，DSP 跳 `/delivery/parcel-sla-monitoring`。
 */
export const buildParcelSlaMonitoringUrl = (warehouseId: number, localDate: string, dsp: boolean): string => {
    const params = new URLSearchParams({
        warehouseIds: String(warehouseId),
        arrivalDateStart: localDate,
        arrivalDateEnd: localDate,
        arrivalPointType: ARRIVAL_POINT_TYPE_HUB,
    });
    return `${dsp ? '/delivery' : '/wms/delivery'}/parcel-sla-monitoring?${params.toString()}`;
};
